import 'babel-polyfill'
import Vue from 'vue';
import router from './router';
import ElementUI from 'element-ui';
import './components/util/Function'
import './components/util/directives.js'
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './components/util/permission.js'
import '../src/assets/css/cover.css'
import locale from '../src/assets/js/elementlocalmonth.js'
import selShowLimit from './directives/selShowLimit' // 引入指令
import htmlToPdf from './components/util/Function/htmlToPdf.js'
Vue.use(htmlToPdf)
import App from './App.vue';
Vue.use(ElementUI, {
	size: 'small',
	 locale: {...locale },
});
import taxui from 'tax-ui'
Vue.use(taxui)
// 全局注册指令
Vue.directive('selShowLimit', selShowLimit);


new Vue({
	router,
	render: h => h(App)
}).$mount('#app');


import BigNumber from 'bignumber.js'
Vue.prototype.$calc = {
	// 加法
	add(a, b) {
		return new BigNumber(String(a)).plus(String(b)).toNumber()
	},

	// 减法
	subtract(a, b) {
		return new BigNumber(String(a)).minus(String(b)).toNumber()
	},

	// 乘法
	multiply(a, b) {
		return new BigNumber(String(a)).times(String(b)).toNumber()
	},

	// 除法
	divide(a, b) {
		if (Number(b) === 0) return 0
		return new BigNumber(String(a)).div(String(b)).toNumber()
	},

	// 保留小数位数（四舍五入）
	toFixed(num, decimalPlaces = 2) {
		return new BigNumber(String(num)).toFixed(decimalPlaces)
	},

	// 比较大小
	compare(a, b) {
		return new BigNumber(String(a)).comparedTo(String(b))
	},

	// 判断是否相等
	isEqual(a, b) {
		return new BigNumber(String(a)).isEqualTo(String(b))
	},

	// 获取精确的字符串表示
	toString(num) {
		return new BigNumber(String(num)).toString()
	}
}